export default __webpack_public_path__ + "static/bentoSectionBg6-321196cbb31d0723f9a7320e703a29e6.webp";